import { render } from "./pos-dashboard.vue?vue&type=template&id=067de4d4&scoped=true"
import script from "./pos-dashboard.vue?vue&type=script&lang=js"
export * from "./pos-dashboard.vue?vue&type=script&lang=js"

import "./pos-dashboard.vue?vue&type=style&index=0&id=067de4d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067de4d4"]])

export default __exports__